import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue'
import { OperateBorderLines } from '@/types/edit'


export default /*#__PURE__*/_defineComponent({
  __name: 'BorderLine',
  props: {
  type: {
    type: String as PropType<OperateBorderLines>,
    required: true,
  },
  isWide: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['border-line', __props.type, { 'wide': __props.isWide }])
  }, null, 2))
}
}

})